// --- 1checkout.js v2
// <<<<<<<<<<<<<<<<< WARNING! >>>>>>>>>>>>>>>>>>
// Never change these consts directly. Always use the settings page to configure them
const IS_DEMO_PAGE = false;
const CHECKOUT_API_HOST = 'https://api.1checkout.ai';
const CHECKOUT_HOST = 'https://pay.1checkout.ai';
const CHECKOUT_API_KEY = 'c14e937d-1a5b-4060-b6b3-b24fbb5068c2';
const IS_1C_DISABLED = true;
const IS_DISABLED_OUTSIDE_INDIA = false;

// --- VARIABLES & CONSTS
var CHECKOUT_CLIENT_IP_ADDRESS = null;
try {
  fetch('https://api.ipify.org?format=json')
    .then((response) => response.json())
    .then((data) => {
      try {
        CHECKOUT_CLIENT_IP_ADDRESS = data.ip
      } catch (error) {};
    });
} catch (error) {};
const API_HEADERS = [
  ['Content-type', 'application/json'],
  ['X-LOGISY-API-KEY', CHECKOUT_API_KEY]
];
var CHECKOUT_ID;
const URL_PARAMS = new URLSearchParams(window.location.search);
var VISITOR_COUNTRY_CODE = null;
var FALLBACK = get1CheckoutLocalStorage('d1c');
var TRIGGER_1CHECKOUT = URL_PARAMS.get('t1c');
TRIGGER_1CHECKOUT = TRIGGER_1CHECKOUT && TRIGGER_1CHECKOUT.toLowerCase() == 'true';
var REFRESH_CART = URL_PARAMS.get('refresh');
REFRESH_CART = REFRESH_CART && REFRESH_CART.toLowerCase() == 'true';
var CHECKOUT_CART = {
  getCartItemCount: function() {
    var count = 0;
    CHECKOUT_CART.items.forEach(item => {
      count += item.quantity;
    });
    return count;
  },
  getCartItemDetails: function() {
    var items = [];
    CHECKOUT_CART.items.forEach(item => {
      items.push({
        id: item.id.toString(),
        quantity: item.quantity,
        name: item.title
      });
    });
    return items;
  },
  getCartProductIds: function() {
    var ids = [];
    CHECKOUT_CART.items.forEach(item => {
      ids.push(item.product_id.toString());
    });
    return ids;
  }
};

// --- HELPER FUNCTIONS
function apiRequest(method, url, headers, data, success, error, complete=null) {
  var xhttp = new XMLHttpRequest();
  xhttp.open(method, url, true);
  headers.forEach(header => {
    xhttp.setRequestHeader(header[0], header[1]);
  });
  xhttp.onreadystatechange = function () {
    if (xhttp.readyState === 4) {
      if (xhttp.status === 200) {
        success(JSON.parse(this.responseText));
      } else {
        error(JSON.parse(this.responseText));
      };
      if (complete) {
        complete();
      };
    };
  };
  xhttp.send(JSON.stringify(data));
};

function set1CheckoutLocalStorage(key, value, expiry_hrs) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (expiry_hrs*60*60*1000));
  expires = expires.toUTCString();

  localStorage.setItem(key, JSON.stringify({
    value: value,
    expires: expires}));
};

function get1CheckoutLocalStorage(key) {
  try {
    var _data = JSON.parse(localStorage.getItem(key));
    var now = (new Date()).getTime();
    var expires = Date.parse(_data.expires);
    
    if (expires > now) {
      return _data.value;
    } else {
      delete1CheckoutLocalStorage(key);
      return null;
    }
  } catch (err) {
    return null;
  };
};

function delete1CheckoutLocalStorage(key) {
  localStorage.removeItem(key);
};

function get1CheckoutCookie(key) {
  for (var o = key + "=", r = decodeURIComponent(document.cookie).split(";"), n = 0; n < r.length; n++) {
    for (var t = r[n];
      " " == t.charAt(0);) t = t.substring(1);
    if (0 == t.indexOf(o)) return t.substring(o.length, t.length)
  };
  return null;
};

function show1CheckoutIfEnabled() {
  var disable1Checkout = get1CheckoutLocalStorage('d1c') || IS_1C_DISABLED;
  if (disable1Checkout) {
    fallbackToShopifyCheckout();
  } else if (IS_DISABLED_OUTSIDE_INDIA) {
    VISITOR_COUNTRY_CODE = get1CheckoutLocalStorage('vcc1c');
    if (VISITOR_COUNTRY_CODE == null) {
      apiRequest(
        'GET', 'https://api.ipregistry.co/?key=6f60ccgejq6mhdsu',
        headers=[['Content-type', 'application/json; charset=UTF-8']],
        data={},
        success=function(data) {
          set1CheckoutLocalStorage('vcc1c', data.location.country.code, 12);
          show1CheckoutIfEnabled();
        },
        error=function(err) {
          document.querySelectorAll('.default-checkout-btn').forEach(btn => {
            btn.classList.remove('d-none');
          });
        });
    } else if (VISITOR_COUNTRY_CODE == 'IN') {
      document.querySelectorAll('.btn-1checkout').forEach(btn => {
        btn.classList.remove('d-none');
      });
    } else {
      document.querySelectorAll('.default-checkout-btn').forEach(btn => {
        btn.classList.remove('d-none');
      });
    };
  } else {
    document.querySelectorAll('.btn-1checkout').forEach(btn => {
      btn.classList.remove('d-none');
    });
  };
};
show1CheckoutIfEnabled();

function fallbackToShopifyCheckout() {
  document.querySelectorAll('.btn-1checkout').forEach(btn => {
    btn.classList.add('d-none');
  });
  document.querySelectorAll('.default-checkout-btn').forEach(btn => {
    btn.classList.remove('d-none');
  });
};

var loaderMessages1Checkout = [
  'Carefully wrapping your items',
  'Crossing T’s & dotting I’s',
  'Juuust a moment..',
  'Adding the cherry on top'
];
var loaderMessagesTimer = null;
var _messageIdx = 0;
function startLoaderMessages() {
  loaderMessagesTimer = setInterval(function() {
    document.getElementById('checkoutLoadingMessage').innerHTML = loaderMessages1Checkout[_messageIdx];
    _messageIdx += 1;
    if (_messageIdx == loaderMessages1Checkout.length) {
      resetSplashScreen();
    };
  }, 2000);
};

function resetSplashScreen() {
  // Reset splash screen
  clearInterval(loaderMessagesTimer);
  _messageIdx = 0;
  document.getElementById('checkoutLoadingMessage').innerHTML = 'Initializing...';
  document.querySelector('.checkout-progressbar').classList.add('d-none');
};


// Browser messaging
window.addEventListener('message', function(event) {
  if (event.origin == CHECKOUT_HOST) {
    if (event.data.topic == '1CHECKOUT') {
      if (event.data.message == 'launch_truecaller') {
        document.location = event.data.truecallerDeeplink;
      } else if (event.data.message == 'exit_checkout') {
        document.querySelector('.checkoutmodal .overlay').classList.add('d-none');
        document.querySelector('.checkoutmodal .splash-screen').classList.remove('d-none');
        document.getElementById('checkoutModal').click();
        document.querySelector('.checkoutmodal iframe').remove();
        if (event.data.fallback) {
          // Disable 1C for 4 hours
          set1CheckoutLocalStorage('d1c', true, 4);
        };
        if (event.data.nextPage) {
          window.location.replace(event.data.nextPage);
        };
        // If 1checkout was loaded from WA commerce, refresh on exit to refresh the cart UI
        CHECKOUT_ID = URL_PARAMS.get('cid');
        
        if (CHECKOUT_ID && TRIGGER_1CHECKOUT) {
          window.location.replace(`/cart?cid=${CHECKOUT_ID}&t1c=false&refresh=false`);
        };
      } else if (event.data.message == 'clear_cart') {
        apiRequest(
          'POST', '/cart/clear.js',
          headers=[['Content-type', 'application/json; charset=UTF-8']],
          data={},
          success=function(data) {
          },
          error=function(err) {
          });
      } else if (event.data.message == 'launch_upi_app') {
        document.location = event.data.deeplink;
      } else if (event.data.message == 'checkout_conversion') {
        // Delete UTM params and send fbq and ga
        setTimeout(function() {
          window.location.replace(event.data.nextPage);
        }, 3000);
      } else if (event.data.message == 'create_abandoned_checkout') {
        try {
          fetch(event.data.checkoutUrl)
            .then(response => {});
        } catch (error) {};
      };
    };
  };
}, false);

// --- EXTERNAL TRIGGERS
if (FALLBACK) {
  fallbackToShopifyCheckout();
} else {
  if (TRIGGER_1CHECKOUT) {
    // Showing overlay here but 1checkout triggered after cart is updated
    document.body.style.overflow = 'hidden';
    document.querySelector('.checkout-progressbar').classList.remove('d-none');
    document.getElementById('checkoutModal').checked = true;
    startLoaderMessages();
  };
  if (!TRIGGER_1CHECKOUT && REFRESH_CART) {
    // Show only overlay till cart is updated and page is refreshed
    var loader = '<span style="position: absolute; border: 3px solid #fff; border-top: 3px solid #0000; border-radius: 50%; width: 32px; height: 32px; left: calc(50% - 16px); top: calc(50% - 16px)"></span>';
    var overlay = `<div id="checkoutRedirectOverlay" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(0,0,0,0.9); z-index: 1063;">${loader}</div>`
    document.querySelector('body').innerHTML += overlay;
    document.querySelector('#checkoutRedirectOverlay span').animate(
      [{transform: `rotate(360deg)`}],
      {
        duration: 1000,
        iterations: Infinity
      });
  };
};

//--- Overriding buy now button
function addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData) {
  var item = items.pop();
  if (item) {
    apiRequest(
      'POST', '/cart/add.js',
      headers=[['Content-type', 'application/json; charset=UTF-8']],
      data={
        'items': [item]
      },
      success=function(data) {
      },
      error=function(err) {
        unaddedItems.push(err.description);
      },
      complete=function() {
        addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData); 
      });
  } else {
    if (unaddedItems.length > 0) {
      unaddedItemsHtml = '';
      unaddedItems.forEach(item => {
        unaddedItemsHtml += `<li style="text-align: left;">${item}</li>`;
      })
      var title = '<h3 style="text-align: center; color: #404143;">Oops!</h3>';
      var message = `<div style="text-align: center; color: #404143;"><ul style="max-height: 118px;overflow-y: auto;">${unaddedItemsHtml}</ul></div>`;
      var goHomeLink = `<a href="/cart" style="margin-top: 16px;background-color: #404143;color: #fff;padding: 8px 46px;border-radius: 4px;text-decoration: none;">Ok</a>`;
      var style = 'position: absolute; display: flex; flex-direction: column; align-items: center;';
      style += 'width: 350px; left: calc(50% - 175px); top: 30%;';
      style += 'background-color: #fff; border-radius: 4px; padding: 16px;';
      var showError = `<div style="${style}">${title}${message}${goHomeLink}</div>`;
      document.getElementById('checkoutRedirectOverlay').innerHTML = showError;
    } else {
      if (TRIGGER_1CHECKOUT) {
        initCheckoutIframe({
          showError: false,
          phone: checkoutData.customer.phone});
      } else if (REFRESH_CART) {
        window.location.replace('/cart');
      };
    };
  };
};
// Trigger WA 1Commerce flow
function triggerWA1CheckoutOnPageLoad() {
  if (['/cart', '/cart/'].includes(window.location.pathname) && !FALLBACK && REFRESH_CART) {
    CHECKOUT_ID = URL_PARAMS.get('cid');
    if (CHECKOUT_ID) {
      // Fetch the checkout info from server
      apiRequest(
        'GET', `${CHECKOUT_API_HOST}/checkouts/${CHECKOUT_ID}`,
        headers=API_HEADERS,
        data={},
        success=function(checkoutData) {
          // Clear the cart
          apiRequest(
            'GET', '/cart/clear.js',
            headers=[['Content-type', 'application/json; charset=UTF-8']],
            data={},
            success=function(data) {
              var items = [];
              checkoutData.cart.items.forEach(item => {
                items.push({
                  'id': item.variant_id,
                  'quantity': item.quantity});
              });
              var unaddedItems = [];
              addOneItemAfterAnotherToCart(items, unaddedItems, checkoutData);
            },
            error=function(err) {
            },
            complete=function() {
            });
        },
        error=function(err) {
          console.log(err);  // TODO
        });
    };
  };
};

// Toggle enable/disable 1Checkout btn when a separate variant is selected
function checkVariantAvailability(variantId) {
  var productHandle = document.getElementById('productHandle1Checkout').value;
  if (productHandle) {
    apiRequest(
      'GET', `/products/${productHandle}.js`,
      headers=[['Content-type', 'application/json; charset=UTF-8']],
      data={},
      success=function(data) {
        var variantAvailable = true;
        data.variants.forEach(variant => {
          if (variant.id == variantId) {
            variantAvailable = variant.available;
          };
        });
        if (!variantAvailable) {
          document.getElementById('buyNow1CheckoutBtn').disabled = true;
        } else {
          document.getElementById('buyNow1CheckoutBtn').disabled = false; 
        };
      },
      error=function(err) {
      });
  } else {
    document.getElementById('buyNow1CheckoutBtn').disabled = false;
  };
  document.getElementById('buyNow1CheckoutError').classList.add('d-none');
};

window.addEventListener('load', function() {
  triggerWA1CheckoutOnPageLoad();
  // Registering event for availability check 
  try {
    document.querySelector('[name="id"]').addEventListener('change', function() {
      checkVariantAvailability(parseInt(this.value));
    });
  } catch(e) {};
});

// Registering optional event for availability check 
document.addEventListener('variant:changed', function(event) {
  checkVariantAvailability(event.detail.variant.id);
});

// buyNow1CheckoutBtn click
function buyNow1Checkout(el) {
  document.getElementById('buyNow1CheckoutError').classList.add('d-none');
  el.disabled = true;
  el.querySelector('.btn-1checkout-title').classList.add('d-none');
  el.querySelector('.btn-1checkout-sub-title').classList.add('d-none');
  el.querySelector('.btn-1checkout-spinner').classList.remove('d-none');
  var variantId = document.querySelector('[name="id"]').value;
  try {
    var quantity = document.querySelector('[name="quantity"]').value; 
  } catch (error) {
    var quantity = 1;
  };
  var properties = {};
  document.querySelectorAll('[name*="properties["]').forEach(el => {
    var propKey = el.getAttribute('name');
    propKey = propKey.match(/\[(.*)\]/i);
    if (propKey.length > 1) {
      properties[propKey[1]] = el.value;
    };
  });
  apiRequest(
    'GET', '/cart/clear.js',
    headers=[['Content-type', 'application/json; charset=UTF-8']],
    data={},
    success=function(data) {
      apiRequest(
        'POST', '/cart/add.js',
        headers=[['Content-type', 'application/json; charset=UTF-8']],
        data={
          'items': [
            {
              'id': variantId,
              'quantity': quantity,
              'properties': properties
            }
          ]
        },
        success=function(data) {
          // Trigger 1checkout modal
          document.getElementById('checkoutModal').click();
          // Trigger cart update JS event
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: quantity
            }
          }));
        },
        error=function(err) {
          if (err.description) {
            document.getElementById('buyNow1CheckoutError').innerHTML = err.description;
          };
          document.getElementById('buyNow1CheckoutError').classList.remove('d-none');
        });
    },
    error=function(err) {
    },
    complete=function() {
      el.querySelector('.btn-1checkout-title').classList.remove('d-none');
      el.querySelector('.btn-1checkout-sub-title').classList.remove('d-none');
      el.querySelector('.btn-1checkout-spinner').classList.add('d-none');
      el.disabled = false;
    });
};

// Initializing 1Checkout popup
function initialize1Checkout() {
  if (IS_DEMO_PAGE) {
    CHECKOUT_CART = {...CHECKOUT_CART, ...fakeCart};
    // Create a fake checkout object
    apiRequest(
      'POST', `${CHECKOUT_API_HOST}/create`,
      headers=API_HEADERS,
      data=CHECKOUT_CART,
      success=function(data) {
        CHECKOUT_ID = data.checkout_id;
        initCheckoutIframe({showError: false});
      },
      error=function(err) {
        console.log(err);  // TODO
        initCheckoutIframe({showError: true});
      });
  } else {
    // Get the cart json
    apiRequest(
      'GET', '/cart.json',
      headers=[['Content-type', 'application/json']],
      data={},
      success=function(cartJson) {
        CHECKOUT_CART = {...CHECKOUT_CART, ...cartJson};
        // Create checkout object
        apiRequest(
          'POST', `${CHECKOUT_API_HOST}/create`,
          headers=API_HEADERS,
          data=CHECKOUT_CART,
          success=function(data) {
            CHECKOUT_ID = data.checkout_id;
            initCheckoutIframe({showError: false});
          },
          error=function(err) {
            console.log(err);  // TODO
            initCheckoutIframe({showError: true});
          });
      },
      error=function(err) {
        console.log(err);  // TODO
        initCheckoutIframe({showError: true});
      });
  };
};

function checkoutModalToggled(el) {
  if (el.checked == true){
    document.querySelector('.checkout-progressbar').classList.remove('d-none');
    startLoaderMessages();
    document.body.style.overflow = 'hidden';
    initialize1Checkout();
  } else {
    document.body.style.overflow = null;
  };
};

function initCheckoutIframe(params) {
  params['containerheight'] = document.querySelector('.checkoutmodal .inner').offsetHeight;
  params['checkoutid'] = CHECKOUT_ID;
  params['apikey'] = CHECKOUT_API_KEY;

  var iframeUrl = new URL(`${CHECKOUT_HOST}/v2/checkout/widget/`);
  Object.keys(params).forEach(key => {
    if (params[key] !== null) {
      iframeUrl.searchParams.set(key.toLowerCase(), params[key]);
    };
  });

  // Populate fb pixel from cookie
  var fbclid = get1CheckoutCookie('_fbc');
  if (fbclid) {
    iframeUrl.searchParams.set('fbclid', fbclid);
  };

  // Populate IP address
  if (CHECKOUT_CLIENT_IP_ADDRESS) {
    iframeUrl.searchParams.set('ip', CHECKOUT_CLIENT_IP_ADDRESS);
  };

  // Populate utm params
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(utmParam => {
    if (URL_PARAMS.get(utmParam)) {
      iframeUrl.searchParams.set(utmParam, URL_PARAMS.get(utmParam));
    };
  });

  // Populate fb pixel from cookie
  var fbp = get1CheckoutCookie('_fbp');
  if (fbp) {
    iframeUrl.searchParams.set('fbp', fbp);
  };

  // Populate the page url
  iframeUrl.searchParams.set('url', encodeURI(window.location.href));

  document.querySelector('.checkoutmodal .iframe-container').innerHTML = `<iframe src="${iframeUrl.href}" onload="checkoutLoaded()" class="d-none"></iframe>`;
};

function checkoutLoaded() {
  var iframe = document.querySelector('.checkoutmodal iframe');
  iframe.classList.remove('d-none');
  document.querySelector('.checkoutmodal .splash-screen').classList.add('d-none');
  resetSplashScreen();
};